import { teammateMessageActionCardKind } from '@littlebird/action-cards';
import { getSDK, type ActionCard } from '@littlebird/sdk';

import { commitCardFields } from '@/features/action-cards-view/commands';

import { messageOwnerOf } from './hivemind-conversations-status';

// What the user typed and has not sent, by the message group and the text its drafts still hold. Removing the person
// whose card shows the group moves it to the next card, which starts without the state of the first. The entry also
// outlives the editor, which a list that draws only the cards on screen unmounts
export const typedText = new Map<string, string>();

/** The key of a message group's typed text, from the group's first card */
export const typedKeyOf = (first: ActionCard) => {
  const content = teammateMessageActionCardKind.decode(first.content);
  return `${first.chatId}:${messageOwnerOf(first)}:${content?.sent_text ?? content?.draft ?? ''}`;
};

// The edit goes to the card as it is when Send is pressed, and the send carries the revision this save gives
export const saveText = async (cardId: string, text: string) => {
  const card = getSDK().stores.actionCards.get(cardId);
  if (
    !card ||
    teammateMessageActionCardKind.decode(card.content)?.draft === text
  )
    return { saved: true, revision: null };
  let revision: number | null = null;
  await commitCardFields(card, { draft: text }, (savedSyncId) => {
    revision = savedSyncId;
  });
  return { saved: revision !== null, revision };
};
